// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Dvitt","blogs__row":"styles_blogs__row__dRQTQ","load_more":"styles_load_more__9wGST","title":"styles_title__605Vr"};